<template>
  <IEcharts :option="option" />
</template>

<script>
import IEcharts from 'vue-echarts-v3/src/full.js'
export default {
  components: {
    IEcharts
  },
  props: {
    options: {
      type: Array,
      default: function () {
        return []
      }
    }
  },
  data() {
    return {
      option: {
        toolbox: {
          right: '25',
          show: true,
          feature: {
            saveAsImage: {
              title: 'Save',
              iconStyle: {
                borderColor: '#FFF'
              },
              show: true
            }
          }
        },
        legend: {
          type: 'plain'
        },
        series: {
          type: 'sunburst',
          nodeClick: 'rootToNode',
          data: [],
          radius: [0, '95%'],
          label: {
            rotate: 'radial',
            fontWeight: 'bold',
            color: '#414a4c'
          }
        }
      }
    }
  },
  watch: {
    options: {
      handler(val) {
        this.option.series.data = []
        this.option.series.data.push(...val)
      },
      immediate: true
    }
  }
}
</script>
